var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('el-container',[_c('el-header',{attrs:{"height":"0"}},[_c('NavBar'),_c('MobileNavBar')],1),_c('el-main',{staticStyle:{"padding":"0"}},[_c('SideTool'),_c('router-view')],1),_c('el-footer',{staticStyle:{"padding":"0"}},[_c('CallMe'),_c('MobileCallMe')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }